<template>
  <div class="not-found">
    <div class="circle"></div>
    <div class="text">
      <p>No Properties Found</p>
      <span>try adjust your search to find that you are looking for</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.not-found {
  height: 100%;
  width: 100%;
  position: relative;
  color: rgba(255, 255, 255, 0.3);
  .circle {
    height: 70%;
    width: 80vw;
    border-radius: 50%;
    box-shadow: 75px 30px 0px 0px rgba(255, 255, 255, 0.1);
  }
  .text {
    position: absolute;
    p {
      font-size: $text-xxxl;
      font-weight: 600;
    }
    span {
      margin-top: 0.3rem;
      font-size: $text-lg;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
